(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-blog-2"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('custom-blog-{{ section.id }}');
  if(!root) return;

  var featured = root.querySelector('.featured_main3');
  if(!featured) return;

  var pc = featured.getAttribute('data-bg-pc') || '';
  var mb = featured.getAttribute('data-bg-mb') || '';

  function applyBg(){
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var url = isMobile ? mb : pc;
    if(url){
      featured.style.backgroundImage = "url('" + url + "')";
      featured.style.backgroundRepeat = "no-repeat";
      featured.style.backgroundSize = "cover";
      featured.style.backgroundPosition = "center";
    }
  }

  applyBg();
  window.addEventListener('resize', applyBg);
})();

  } catch(e) { console.error(e); }
})();
})();
